import React from "react";

// Metallic sheen overlay. Renders ONLY the existing .metallic-sweep-overlay class
// (the transparent moving sweep band from metallic.js / index.css) as an absolute
// layer, so it composites ON TOP of an element's own fill (gold / silver / bronze
// gradient, a purple name, a coloured check) without replacing it. This is the
// additive path: gradient plus sheen, never sheen instead of gradient. Reuses the
// one metallic system; adds no new keyframes or colours.
export const MetallicSheen = ({ radius = "9999px", blend = "overlay", className = "" }) => (
  <span
    aria-hidden="true"
    className={`metallic-sweep-overlay ${className}`}
    style={{ position: "absolute", inset: 0, borderRadius: radius, pointerEvents: "none", mixBlendMode: blend }}
    data-testid="metallic-sheen"
  />
);

export default MetallicSheen;
